module.exports = __webpack_public_path__ + "static/media/dinho.66f225ae.webp";